// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__EVYFG","icon":"SortAdornment_icon__3kmiU","up":"SortAdornment_up__1SzId","down":"SortAdornment_down__1QyNB","active":"SortAdornment_active__mkPy-"};